import * as React from 'react'

type QuerySelectorReturn = Element | null
type AnyElement = QuerySelectorReturn | QuerySelectorReturn[] | NodeListOf<HTMLElement>

export function useToggleStaticElements(elementToHide: AnyElement, elementToShow: AnyElement = [], enabled = true) {
  React.useEffect(() => {
    const hideElement = (element: QuerySelectorReturn) => element?.classList.add('hidden')
    const showElement = (element: QuerySelectorReturn) => element?.classList.remove('hidden')
    const toggleElements = (element: AnyElement, toggleFn: typeof hideElement) => {
      if (element instanceof NodeList || Array.isArray(element)) {
        element.forEach(toggleFn)
      } else {
        toggleFn(element)
      }
    }

    if (enabled) {
      toggleElements(elementToHide, hideElement)
      toggleElements(elementToShow, showElement)
    }

    return () => {
      toggleElements(elementToHide, showElement)
      toggleElements(elementToShow, hideElement)
    }
  }, [elementToHide, elementToShow, enabled])
}
